module.exports = __webpack_public_path__ + "media/svg-new/logo-full2-84266279.svg";